/* Giubbotti Store IT – theme.js (vanilla, nessuna dipendenza) */
(function () {
  'use strict';

  var $ = function (sel, ctx) { return (ctx || document).querySelector(sel); };
  var $$ = function (sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); };
  var strings = window.themeStrings || {};
  var routes = window.routes || { cart_add_url: '/cart/add', cart_change_url: '/cart/change', cart_url: '/cart', root_url: '/' };
  var themeSettings = window.themeSettings || {};

  /* ---------- Blocco scroll ---------- */
  function lock(on) { document.documentElement.style.overflow = on ? 'hidden' : ''; }

  /* ---------- Toast ---------- */
  var toastTimer;
  function toast(msg) {
    var t = $('#Toast');
    if (!t) return;
    t.textContent = msg;
    t.classList.add('is-visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { t.classList.remove('is-visible'); }, 2600);
  }

  /* ---------- Pannelli apri/chiudi ---------- */
  function openPanel(el) { if (!el) return; el.classList.add('is-open'); el.setAttribute('aria-hidden', 'false'); lock(true); }
  function closePanel(el) { if (!el) return; el.classList.remove('is-open'); el.setAttribute('aria-hidden', 'true'); lock(false); }

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (t.closest('[data-menu-open]')) { openPanel($('#MobileNav')); }
    if (t.closest('[data-menu-close]')) { closePanel($('#MobileNav')); }
    if (t.closest('[data-search-open]')) {
      var s = $('#SearchModal'); openPanel(s);
      var inp = s && s.querySelector('input[type="search"]'); if (inp) setTimeout(function () { inp.focus(); }, 50);
    }
    if (t.closest('[data-search-close]') || t.id === 'SearchModal') { closePanel($('#SearchModal')); }
    var mo = t.closest('[data-modal-open]');
    if (mo) { openPanel(document.getElementById(mo.getAttribute('data-modal-open'))); }
    if (t.closest('[data-modal-close]') || t.classList.contains('modal')) { closePanel(t.closest('.modal')); }
    if (t.closest('[data-cart-open]') && $('#CartDrawer')) { e.preventDefault(); openPanel($('#CartDrawer')); }
    if (t.closest('[data-drawer-close]')) { closePanel($('#CartDrawer')); }
    var q = t.closest('[data-qty-change]');
    if (q) { e.preventDefault(); changeLine(q.getAttribute('data-line'), q.getAttribute('data-qty')); }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    $$('.is-open').forEach(function (el) { closePanel(el); });
  });

  /* ---------- Date lavorative ---------- */
  function shipDate(cutoff) {
    var now = new Date();
    var ship = new Date(now);
    if (now.getHours() >= cutoff) ship.setDate(ship.getDate() + 1);
    while (ship.getDay() === 0 || ship.getDay() === 6) ship.setDate(ship.getDate() + 1);
    return ship;
  }
  function addWorkdays(d, n) {
    var r = new Date(d);
    while (n > 0) { r.setDate(r.getDate() + 1); if (r.getDay() !== 0 && r.getDay() !== 6) n--; }
    return r;
  }
  var fmtDay = new Intl.DateTimeFormat('it-IT', { weekday: 'short', day: 'numeric', month: 'short' });

  /* ---------- Carrello ---------- */
  function updateBadge(count) {
    $$('[data-cart-count-badge]').forEach(function (b) {
      b.textContent = count > 0 ? count : '';
      b.setAttribute('data-count', count);
    });
  }

  function refreshDrawer(open) {
    var drawer = $('#CartDrawer');
    if (!drawer) {
      if (open) window.location.href = routes.cart_url;
      return Promise.resolve();
    }
    return fetch(routes.cart_url + '?section_id=cart-drawer')
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('#CartDrawer');
        if (fresh) {
          drawer.innerHTML = fresh.innerHTML;
          updateBadge(parseInt(fresh.getAttribute('data-cart-count'), 10) || 0);
        }
        if (open) openPanel(drawer);
      });
  }

  function changeLine(line, qty) {
    var drawer = $('#CartDrawer');
    if (drawer) drawer.style.opacity = '.98';
    return fetch(routes.cart_change_url + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ line: parseInt(line, 10), quantity: parseInt(qty, 10) })
    })
      .then(function (r) { return r.json(); })
      .then(function () { return refreshDrawer(false); })
      .catch(function () { toast(strings.error); })
      .finally(function () { if (drawer) drawer.style.opacity = ''; });
  }

  function addToCart(variantId, qty, button, goToCheckout) {
    var original = button ? button.innerHTML : '';
    if (button) { button.disabled = true; button.classList.add('is-loading'); }
    return fetch(routes.cart_add_url + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: qty || 1 }] })
    })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
      .then(function (res) {
        if (!res.ok) { toast(res.data.description || res.data.message || strings.error); return; }
        if (goToCheckout) {
          window.location.href = (routes.root_url || '/').replace(/\/?$/, '/') + 'checkout';
          return;
        }
        if (button) button.textContent = strings.added;
        return refreshDrawer(true);
      })
      .catch(function () { toast(strings.error); })
      .finally(function () {
        if (!button) return;
        setTimeout(function () { button.disabled = false; button.classList.remove('is-loading'); button.innerHTML = original; }, goToCheckout ? 4000 : 1200);
      });
  }

  /* ---------- Pagina prodotto ---------- */
  function initProduct() {
    var section = $('[data-product-section]');
    var form = $('#ProductForm');
    var jsonEl = $('[data-product-json]');
    if (!section || !form || !jsonEl) return;

    var data;
    try { data = JSON.parse(jsonEl.textContent); } catch (err) { return; }
    var variants = data.variants || [];
    var idInput = form.querySelector('[data-variant-id]');
    var addBtn = form.querySelector('[data-add-button]');
    var buyBtn = form.querySelector('[data-buy-now]');
    var priceWrap = $('[data-price-wrapper]', section);
    var discountBadge = $('[data-discount-badge]', section);
    var stockNote = $('[data-stock-note]', section);
    var stickyPrice = $('[data-sticky-price]');
    var stickyAdd = $('[data-sticky-add]');
    var fieldsets = $$('[data-option-index]', section);

    function current() {
      var id = parseInt(idInput.value, 10);
      for (var i = 0; i < variants.length; i++) if (variants[i].id === id) return variants[i];
      return variants[0];
    }

    function selectedOptions() {
      return fieldsets.map(function (fs) {
        var sel = fs.querySelector('select');
        if (sel) return sel.value || null;
        var c = fs.querySelector('input:checked');
        return c ? c.value : null;
      });
    }

    function findVariant(opts) {
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i], match = true;
        for (var j = 0; j < opts.length; j++) if (v.options[j] !== opts[j]) { match = false; break; }
        if (match) return v;
      }
      return null;
    }

    function markAvailability() {
      var opts = selectedOptions();
      fieldsets.forEach(function (fs, idx) {
        var sel = fs.querySelector('select');
        if (sel) {
          $$('option', sel).forEach(function (o) {
            if (!o.value) return;
            var t = opts.slice(); t[idx] = o.value;
            var any = variants.filter(function (v) {
              for (var j = 0; j < t.length; j++) if (t[j] !== null && v.options[j] !== t[j]) return false;
              return true;
            });
            var avail = any.some(function (v) { return v.available; });
            o.textContent = o.getAttribute('data-label') + (avail ? '' : ' – esaurito');
          });
          return;
        }
        $$('input', fs).forEach(function (input) {
          var test = opts.slice(); test[idx] = input.value;
          var v = findVariant(test);
          input.classList.toggle('is-unavailable', !v || !v.available);
        });
      });
    }

    function renderStock(v) {
      if (!stockNote) return;
      if (!v || !v.available) {
        stockNote.className = 'stock-note stock-note--out';
        stockNote.innerHTML = '<span class="stock-dot"></span>' + (strings.soldOut || 'Esaurito');
        return;
      }
      if (v.inventory !== null && v.inventory > 0 && v.inventory <= data.low_stock) {
        stockNote.className = 'stock-note stock-note--low';
        stockNote.innerHTML = '<span class="stock-dot"></span>' + (v.inventory === 1 ? 'Ultimo pezzo disponibile' : 'Solo ' + v.inventory + ' pezzi disponibili');
      } else {
        stockNote.className = 'stock-note';
        stockNote.innerHTML = '<span class="stock-dot"></span>Disponibile – pronto per la spedizione';
      }
    }

    function setButtons(enabled, soldOut) {
      if (addBtn) { addBtn.disabled = !enabled; addBtn.textContent = soldOut ? strings.soldOut : strings.addToCart; }
      if (buyBtn) buyBtn.disabled = !enabled;
      if (stickyAdd) stickyAdd.disabled = !enabled;
    }

    function render(v) {
      if (!v) {
        if (needsChoice()) {
          setButtons(true, false);
          if (stockNote) { stockNote.className = 'stock-note'; stockNote.innerHTML = ''; }
          return;
        }
        setButtons(false, false);
        if (addBtn) addBtn.textContent = strings.unavailable;
        return;
      }
      idInput.value = v.id;
      if (priceWrap) {
        priceWrap.innerHTML = '<div class="price' + (v.compare ? ' price--sale' : '') + '"><span class="price__current">' + v.price + '</span>' +
          (v.compare ? '<s class="price__compare">' + v.compare + '</s>' : '') + '</div>';
      }
      if (discountBadge) {
        discountBadge.hidden = !(v.discount > 0);
        if (v.discount > 0) discountBadge.textContent = '-' + Math.round(v.discount) + '%';
      }
      if (stickyPrice) stickyPrice.textContent = v.price.replace(/<[^>]*>/g, '');
      setButtons(v.available, !v.available);
      renderStock(v);
      fieldsets.forEach(function (fs) {
        var c = fs.querySelector('input:checked'), out = fs.querySelector('[data-option-value]');
        if (c && out) out.textContent = c.value;
      });
      if (v.media) {
        var slide = section.querySelector('[data-media-id="' + v.media + '"]');
        var gallery = $('[data-gallery]', section);
        if (slide && gallery && window.innerWidth < 990) gallery.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' });
      }
      if (window.history && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      }
    }

    function needsChoice() {
      return $$('select[data-required-choice]', section).some(function (s) { return !s.value; });
    }
    function promptChoice() {
      var sel = $$('select[data-required-choice]', section).filter(function (s) { return !s.value; })[0];
      if (!sel) return false;
      sel.classList.remove('is-error'); void sel.offsetWidth; sel.classList.add('is-error');
      sel.scrollIntoView({ behavior: 'smooth', block: 'center' });
      setTimeout(function () { sel.focus(); }, 350);
      toast('Scegli prima la tua taglia');
      return true;
    }

    section.addEventListener('change', function (e) {
      if (!e.target.matches('[data-option-input]')) return;
      e.target.classList.remove('is-error');
      render(findVariant(selectedOptions()));
      markAvailability();
    });

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (promptChoice()) return;
      addToCart(parseInt(idInput.value, 10), 1, addBtn, false);
    });

    if (buyBtn) {
      buyBtn.addEventListener('click', function () {
        if (promptChoice()) return;
        addToCart(parseInt(idInput.value, 10), 1, buyBtn, themeSettings.buyNowRedirect !== false);
      });
    }

    if (stickyAdd) {
      stickyAdd.addEventListener('click', function () {
        if (promptChoice()) return;
        var direct = !!buyBtn && themeSettings.buyNowRedirect !== false;
        addToCart(parseInt(idInput.value, 10), 1, stickyAdd, direct);
      });
      var sticky = $('[data-sticky-atc]');
      var watch = buyBtn || addBtn;
      if (sticky && watch && 'IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          entries.forEach(function (en) {
            var below = en.boundingClientRect.top < 0;
            sticky.classList.toggle('is-visible', !en.isIntersecting && below);
          });
        }).observe(watch);
      }
    }

    // Puntini galleria
    var gallery = $('[data-gallery]', section), dots = $$('[data-gallery-dots] button', section);
    if (gallery && dots.length) {
      gallery.addEventListener('scroll', function () {
        var idx = Math.round(gallery.scrollLeft / gallery.clientWidth);
        dots.forEach(function (d, i) { d.classList.toggle('is-active', i === idx); });
      }, { passive: true });
      dots.forEach(function (d, i) {
        d.addEventListener('click', function () { gallery.scrollTo({ left: i * gallery.clientWidth, behavior: 'smooth' }); });
      });
    }

    if (needsChoice()) { render(null); } else { renderStock(current()); }
    markAvailability();
  }

  /* ---------- Timer spedizione + linea temporale ---------- */
  function initShipTimer() {
    var el = $('[data-ship-timer]');
    if (!el) return;
    var cutoff = parseInt(el.getAttribute('data-cutoff'), 10) || 14;
    var min = parseInt(el.getAttribute('data-min'), 10) || 1;
    var max = parseInt(el.getAttribute('data-max'), 10) || 2;
    var txt = $('[data-ship-timer-text]', el);

    function tick() {
      var now = new Date();
      var ship = shipDate(cutoff);
      var a = addWorkdays(ship, min), b = addWorkdays(ship, max);
      var range = fmtDay.format(a) + (max > min ? ' – ' + fmtDay.format(b) : '');
      var isWorkday = now.getDay() !== 0 && now.getDay() !== 6;
      if (isWorkday && now.getHours() < cutoff) {
        var end = new Date(now); end.setHours(cutoff, 0, 0, 0);
        var diff = Math.max(0, end - now);
        var h = Math.floor(diff / 36e5), m = Math.floor((diff % 36e5) / 6e4);
        txt.innerHTML = 'Ordina entro <strong>' + (h > 0 ? h + 'h ' : '') + m + 'min</strong>: spediamo oggi, lo ricevi <strong>' + range + '</strong>';
      } else {
        txt.innerHTML = 'Ordina ora e lo ricevi <strong>' + range + '</strong>';
      }
      var steps = $$('[data-step-date]');
      if (steps.length) {
        steps[0].textContent = 'Oggi';
        steps[1].textContent = (ship.toDateString() === now.toDateString()) ? 'Oggi' : fmtDay.format(ship);
        steps[2].textContent = range;
      }
    }
    tick();
    setInterval(tick, 30000);
  }

  /* ---------- Video TikTok ---------- */
  function initVideos() {
    var cards = $$('[data-autoplay-on-view]');
    if (!cards.length) return;
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          var v = en.target.querySelector('video');
          if (!v) return;
          if (en.isIntersecting) { v.play().catch(function () {}); } else { v.pause(); }
        });
      }, { threshold: 0.6 });
      cards.forEach(function (c) { io.observe(c); });
    }
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-sound-toggle]');
      if (!btn) return;
      var v = btn.parentElement.querySelector('video');
      if (!v) return;
      $$('[data-autoplay-on-view] video').forEach(function (o) {
        if (o !== v) { o.muted = true; var b = o.parentElement.querySelector('[data-sound-toggle]'); if (b) syncIcon(b, true); }
      });
      v.muted = !v.muted;
      if (!v.muted) v.play().catch(function () {});
      syncIcon(btn, v.muted);
    });
    function syncIcon(btn, muted) {
      var off = btn.querySelector('[data-icon-off]'), on = btn.querySelector('[data-icon-on]');
      if (off) off.hidden = !muted;
      if (on) on.hidden = muted;
    }
  }

  /* ---------- Prodotti consigliati ---------- */
  function initRecommendations() {
    $$('[data-recommendations]').forEach(function (el) {
      if (el.querySelector('.card')) return;
      fetch(el.getAttribute('data-url'))
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = doc.querySelector('[data-recommendations]');
          if (fresh && fresh.innerHTML.trim()) el.innerHTML = fresh.innerHTML;
        })
        .catch(function () {});
    });
  }

  /* ---------- Zoom foto recensioni ---------- */
  document.addEventListener('click', function (e) {
    var z = e.target.closest('[data-review-zoom]');
    var sec = e.target.closest('.shopify-section');
    var box = sec ? sec.querySelector('[data-review-lightbox]') : $('[data-review-lightbox]');
    if (z && box) {
      box.querySelector('[data-review-lightbox-img]').src = z.getAttribute('data-review-zoom');
      box.hidden = false; lock(true); return;
    }
    var lb = e.target.closest('[data-review-lightbox]');
    if (lb && (e.target.closest('[data-review-lightbox-close]') || e.target === lb)) { lb.hidden = true; lock(false); }
  });

  /* ---------- Popup newsletter ---------- */
  function initNewsletterPopup() {
    var popup = $('[data-nl-popup]');
    if (!popup) return;
    var teaser = $('[data-nl-open]');
    var KEY = 'nl_popup_closed_until', DONE = 'nl_popup_done';
    var delay = (parseInt(popup.getAttribute('data-delay'), 10) || 0) * 1000;
    var days = parseInt(popup.getAttribute('data-days'), 10) || 7;
    var success = popup.getAttribute('data-success') === 'true';
    var design = popup.getAttribute('data-design') === 'true';
    function get(k) { try { return localStorage.getItem(k); } catch (e) { return null; } }
    function set(k, v) { try { localStorage.setItem(k, v); } catch (e) {} }

    function open() {
      popup.classList.add('is-open'); popup.setAttribute('aria-hidden', 'false'); lock(true);
      if (teaser) teaser.hidden = true;
      var inp = popup.querySelector('input[type="email"]');
      if (inp && window.innerWidth >= 750) setTimeout(function () { inp.focus(); }, 300);
    }
    function close() {
      popup.classList.remove('is-open'); popup.setAttribute('aria-hidden', 'true'); lock(false);
      if (!get(DONE)) {
        set(KEY, String(Date.now() + days * 864e5));
        if (teaser) teaser.hidden = false;
      }
    }

    if (success) { set(DONE, '1'); }
    if (popup.classList.contains('is-open')) lock(true);

    popup.addEventListener('click', function (e) {
      if (e.target.closest('[data-nl-close]')) { e.preventDefault(); close(); }
      var c = e.target.closest('[data-nl-copy]');
      if (c) {
        var code = popup.querySelector('[data-nl-code]').textContent.trim();
        (navigator.clipboard ? navigator.clipboard.writeText(code) : Promise.reject()).then(function () {
          c.textContent = 'Copiato ✓';
        }).catch(function () { c.textContent = code; });
      }
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && popup.classList.contains('is-open')) close(); });
    if (teaser) teaser.addEventListener('click', open);

    if (design) {
      document.addEventListener('shopify:section:select', function (e) { if (e.target.contains(popup)) open(); });
      document.addEventListener('shopify:section:deselect', function (e) { if (e.target.contains(popup)) { popup.classList.remove('is-open'); lock(false); } });
      return;
    }

    if (get(DONE) || popup.classList.contains('is-open')) return;
    var until = parseInt(get(KEY) || '0', 10);
    if (until > Date.now()) { if (teaser) teaser.hidden = false; return; }

    var shown = false;
    function trigger() { if (shown) return; shown = true; open(); }
    setTimeout(trigger, delay);
    if (popup.getAttribute('data-exit') === 'true' && window.matchMedia('(pointer:fine)').matches) {
      document.addEventListener('mouseout', function (e) { if (!e.relatedTarget && e.clientY <= 0) trigger(); });
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    initProduct();
    initShipTimer();
    initVideos();
    initRecommendations();
    initNewsletterPopup();
  });
})();
